import { Component, Inject, Optional } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccionesDialog } from '@models/base/identificadores.model';
import { TipoAjusteContratoDto } from '@models/tipo-ajuste-contrato/tipoAjusteContratoDto.model';

@Component({
  selector: 'app-dialog-tipo-ajuste-contrato',
  templateUrl: './dialog-tipo-ajuste-contrato.component.html',
  styleUrls: ['./dialog-tipo-ajuste-contrato.component.css']
})
export class DialogTipoAjusteContratoComponent {


  action:string;
  local_data:any;
  form: any;
  formBuilder: FormBuilder = new FormBuilder;

  get f() { return this.form.controls; }

  constructor(
    public dialogRef: MatDialogRef<DialogTipoAjusteContratoComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: TipoAjusteContratoDto) {
    this.local_data = {...data};
    this.action = this.local_data.action;

    this.form = this.formBuilder.group({
      Acronimo: ["", Validators.compose([Validators.required,])],
      Descripcion: ["", Validators.compose([Validators.required,])],
    })

    if (this.action != AccionesDialog.Agregar){
      this.form.controls["Descripcion"].setValue(this.local_data.descripcion)
    }
  }

  doAction(){
    this.dialogRef.close({event:this.action,data:this.local_data});
  }

  closeDialog(){
    this.dialogRef.close({event:AccionesDialog.Cancelar});
  }

  ngOnInit(): void {
  }
}
